module.exports = __webpack_public_path__ + "static/media/selected_icn_map_event_lavori.3840f772.svg";